import { GetServicesOptions } from './get-services'

export const serviceKeys = {
  all: ['services'] as const,
  lists: () => [...serviceKeys.all, 'list'] as const,
  list: (filters: GetServicesOptions) => [...serviceKeys.lists(), { filters }] as const,
  'inf-list': (filters: GetServicesOptions) => [...serviceKeys.lists(), 'inf', { filters }] as const,
  details: () => [...serviceKeys.all, 'detail'] as const,
  detail: (sid: string) => [...serviceKeys.details(), sid] as const,
}
